import { render } from "./ModalLoginZaloOa.vue?vue&type=template&id=25cebac1&scoped=true"
import script from "./ModalLoginZaloOa.vue?vue&type=script&lang=js"
export * from "./ModalLoginZaloOa.vue?vue&type=script&lang=js"

import "./ModalLoginZaloOa.vue?vue&type=style&index=0&id=25cebac1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25cebac1"]])

export default __exports__